import { LoadingStatus, StatusWidgetContainer } from '@apps-common/apps/portal/pages/units/pages/manage/components'
import classNames from 'classnames'

interface IProps {
  loading: boolean
  isInactive: boolean
  data: string | undefined
  classes?: string
}

export const AccountStatus = ({ loading, isInactive, data, classes }: IProps) => {
  if (loading) {
    return <LoadingStatus />
  }

  const value = isInactive ? 'TBC' : data

  return (
    <StatusWidgetContainer>
      <div
        className={classNames(
          classes,
          'text-text-muted text-center px-[6px] py-[4px] rounded-[12px] flex flex-col items-center justify-between gap-[2px] h-[50px] sm:h-[60px] w-[58px]'
        )}
      >
        <div className='grow px-[3px] pt-[2px] sm:pt-[3px] rounded-[5px] text-[0.8em] md:text-[0.9em] jost-bold flex items-center justify-center'>
          {value}
        </div>
        <div className='uppercase jost-medium text-[9px] sm:text-[9px] sm:pb-[3px]'>Account</div>
      </div>
    </StatusWidgetContainer>
  )
}
